<template>
    <div class="pb-32 font-sans">
        <div class="container mx-auto max-w-(--breakpoint-xl) px-3 md:px-8" data-test="dashboard-header">
            <page-header>
                Franchise Hub Dashboard

                <template v-slot:actions>
                    <vx-tabs v-model="width" size="sm" data-test="width-tabs">
                        <vx-tab value="contained">Contained</vx-tab>
                        <vx-tab value="full">Full</vx-tab>
                    </vx-tabs>

                    <vx-tabs v-model="vertical" size="sm">
                        <vx-tab value="service_brands">Service</vx-tab>
                        <vx-tab value="qsr">QSR</vx-tab>
                    </vx-tabs>

                    <vx-tabs v-model="dataSource" size="sm">
                        <vx-tab value="voxie">Voxie</vx-tab>
                        <vx-tab value="omni">Omni</vx-tab>
                    </vx-tabs>

                    <vx-button
                        @click="configuring = !configuring"
                        data-test="configure"
                        type="button"
                        size="sm"
                        :color="configuring ? 'primary' : 'muted-dark'"
                    >
                        <font-awesome-icon widthAuto :icon="faSliders"></font-awesome-icon>
                        Configure
                    </vx-button>
                </template>
            </page-header>
        </div>

        <div
            class="mx-auto px-3 md:px-8"
            :class="width === 'full' ? 'w-full' : 'container max-w-(--breakpoint-xl)'"
            data-test="dashboard-content"
        >
            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
                <p class="col-span-full text-slate-400">Cards are coming soon.</p>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { faSliders } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxButton, VxTab, VxTabs } from '@voxie/frontend-components';
import PageHeader from '~/components/general/PageHeader.vue';

const width = ref<'contained' | 'full'>('contained');
const vertical = ref<'service_brands' | 'qsr'>('service_brands');
const dataSource = ref<'voxie' | 'omni'>('voxie');
const configuring = ref(false);
</script>
